import { ImageDescription } from 'components/structures/general';
import {
  bgAboutUs,
  image1AboutUs,
  image1AboutUs2x,
  sectionForConstruction,
  sectionForConstructionMob,
  sectionForEnergy,
  sectionForEnergyMob,
  sectionForFulfillment,
  sectionForFulfillmentMob,
} from 'images/main';
import { aboutSlide1, aboutSlide2, aboutSlide3, aboutSlide3x2, aboutSlideEasiConnect } from 'images/main/about-us';
import { NextPage } from 'next';
import React from 'react';
import { SEO } from 'templates/layout';
import { GetInTouch, OfficeLocations, OurApproach, OurProjects, PartnersPrompter, Slider } from 'templates/main';
import { construction, constructionMob, forestry, forestryMob, mining, miningMob } from "../images/main/slider";

const Main: NextPage = () => {
  return (
    <>
      <SEO
        title="Home"
        description="A software solutions company offering web development services, devising marketing strategy, and leveraging IT services for businesses and public organizations."
      />

      <Slider
        sliderList={[
          {
            upperTitle: 'GPM for OSP Construction',
            title: 'Build, Track, and Manage OSP Projects with Precision',
            image: sectionForConstruction,
            imageMob: sectionForConstructionMob,
            buttons: [
              { text: 'Read More', link: '/gpm/osp', variant: 'contained' },
              { text: 'GPM', link: 'https://gpmgis.com/', variant: 'outlined' },
            ],
          },
          {
            upperTitle: 'GPM for Fulfillment Services',
            title: 'Optimized Fulfillment from Installation to Restoration',
            image: sectionForFulfillment,
            imageMob: sectionForFulfillmentMob,
            buttons: [
              { text: 'Read More', link: '/gpm/fulfillment-services', variant: 'contained' },
              { text: 'GPM', link: 'https://gpmgis.com/', variant: 'outlined' },
            ],
          },
          {
            upperTitle: 'GPM for Power Projects',
            title: 'Seamless Management for Power Projects',
            image: sectionForEnergy,
            imageMob: sectionForEnergyMob,
            buttons: [
              { text: 'Read More', link: '/gpm/power-grid', variant: 'contained' },
              { text: 'GPM', link: 'https://gpmgis.com/', variant: 'outlined' },
            ],
          },
          {
            upperTitle: 'GPM for Construction & Civil Engineering',
            title: 'Seamless Management from Blueprint to Build',
            image: construction,
            imageMob: constructionMob,
            buttons: [
              { text: 'Read More', link: '/gpm/construction', variant: 'contained' },
              { text: 'GPM', link: 'https://gpmgis.com/', variant: 'outlined' },
            ],
          },
          {
            upperTitle: 'GPM for Forestry Management',
            title: 'Geospatial Oversight for Sustainable Resource Extraction',
            image: forestry,
            imageMob: forestryMob,
            buttons: [
              { text: 'Read More', link: '/gpm/forestry-management', variant: 'contained' },
              { text: 'GPM', link: 'https://gpmgis.com/', variant: 'outlined' },
            ],
          },
          {
            upperTitle: 'GPM for Mining & Extraction Operations',
            title: 'Optimize Drilling, Transport, and Safety Oversight',
            image: mining,
            imageMob: miningMob,
            buttons: [
              { text: 'Read More', link: '/gpm/mining', variant: 'contained' },
              { text: 'GPM', link: 'https://gpmgis.com/' },
            ],
          },
        ]}
      />

      <OurApproach subTitle={'How we do it?'} title={'Our Approach'} button={'Our Services'} />

      <ImageDescription
        image={{ image: aboutSlide1, srcSet: `${image1AboutUs} 1x, ${image1AboutUs2x} 2x,` }}
        bgImage={{ image: bgAboutUs }}
        upperTitle="About Us"
        title="Discover US Software Solutions"
        text="US Software Solutions offers a full range of IT services focused on delivering high-end digital solutions for businesses and public organizations in the Energy sector. Thanks to a team consisting exclusively of experts in their field, we are ready to supervise any project, regardless of its complexity and scale."
        link={{ text: 'Company', href: '/company' }}
      />

      <OurProjects
        sliderList={[
          {
            title: { text: 'EasiConnect', colorLeft: '#172D62', colorRight: '#172D62' },
            image: { image: aboutSlideEasiConnect, srcSet: `${aboutSlideEasiConnect} 1x, ${aboutSlideEasiConnect} 2x,` },
            link: '/easiConnect',
          },
          {
            title: { text: 'Patron Trucking', colorLeft: '#006DC1', colorRight: '#3B94DA' },
            image: { image: aboutSlide2, srcSet: `${aboutSlide2} 1x, ${aboutSlide2} 2x,` },
            link: '/patron-trucking',
          },
          // {
          //   title: { text: 'Utilities One', colorLeft: '#D74136', colorRight: '#F58922' },
          //   image: { image: aboutSlide3, srcSet: `${aboutSlide3} 1x, ${aboutSlide3x2} 2x,` },
          //   link: '/utilities-one',
          // },
        ]}
      />
      {/* TODO Uncomment if this section is needed */}
      {/* <StatisticsSection
        statistics={[
          {
            numberValue: 97,
            text: 'Test Coverage',
            suffix: '%',
          },
          {
            numberValue: 126720,
            text: 'Development Hours',
          },
          {
            numberValue: 5,
            text: 'Years Hard Work',
          },
          {
            numberValue: 30,
            text: 'Our Partners',
            prefix: '+',
          },
        ]}
      /> */}

      <PartnersPrompter />
      <OfficeLocations />
      <GetInTouch
        title="Get in touch"
        text="We're just a few clicks away! Feel free to contact us by clicking below."
        link={{ text: 'Contact Us', href: '/contact-us' }}
      />
    </>
  );
};

export default Main;
